<template>
    <Modal :centered="true" v-model:open="open" title="添加收货地址" :footer="null" @cancel="close" :maskClosable="false"
        :width="550">
        <Spin :spinning="spinning">
            <Card>
                <Form :model="formState" name="basic" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }" autocomplete="on"
                    @finish="onFinish">
                    <FormItem label="收货人" name="name"
                        :rules="[{ required: true, validator: validatePass, trigger: 'change', }]">
                        <Input v-model:value="formState.name" :maxlength="30" :showCount="true" placeholder="请输入收货人" />
                    </FormItem>
                    <FormItem label="收货电话" name="phone"
                        :rules="[{ required: true, validator: validatePass, trigger: 'change', }]">
                        <Input v-model:value="formState.phone" :maxlength="11" :showCount="true" placeholder="请输入收货电话" />
                    </FormItem>
                    <FormItem label="收货地址" name="details"
                        :rules="[{ required: true, validator: validatePass, trigger: 'change', }]">
                        <Textarea v-model:value="formState.details" :maxlength="100" placeholder="请输入收货地址"></Textarea>
                    </FormItem>
                    <FormItem :wrapperCol="{ offset: 0, span: 24 }">
                        <Button type="primary" html-type="submit" style="width:100%">确定</Button>
                        <Button type="primary" danger @click="close" style="width:100%; margin-top: 10px;">取消</Button>
                    </FormItem>
                </Form>
            </Card>
        </Spin>
    </Modal>
</template>

<script>
import { reactive, toRefs, getCurrentInstance } from 'vue'
import { Modal, Spin, Form, Input, Button, Card, Textarea } from "ant-design-vue";
import Que from "./que.js";

export default {
    name: "addressAdd",
    components: { Modal, Spin, Form, FormItem: Form.Item, Input, Button, Card, Textarea },
    setup(props, { emit }) {
        const { proxy } = getCurrentInstance();
        const state = reactive({
            open: true,
            spinning: false,
            Que,
        })
        const close = () => {
            emit("close")
        }
        const formState = reactive({
            name: '',
            details: "",
            phone: "",
        });
        const validatePass = (rule, value) => {
            switch (rule.field) {
                case "name":
                    if (value == "") {
                        return Promise.reject("收货人不能为空")
                    }
                    break;
                case "details":
                    if (value == "") {
                        return Promise.reject("收货地址不能为空")
                    }
                    break;
                case "phone":
                    if (!/^(((13[0-9]{1})|(15[0-9]{1})|(18[0-9]{1}))+\d{8})$/.test(value)) {
                        return Promise.reject("收货电话错误")
                    }
                    break;
                default:
                    break;
            }
            return Promise.resolve()
        };
        const onFinish = async (value) => {
            state.spinning = true;
            var result = await Que.post(proxy, value)
            state.spinning = false;
            if (result) {
                close()
            }
        };
        return {
            ...toRefs(state), close, onFinish, formState, validatePass
        }
    }
}
</script>

<style lang="scss" scoped></style>